import { render, staticRenderFns } from "./AjanlatArImportModal.vue?vue&type=template&id=71d0ce36&scoped=true"
import script from "./AjanlatArImportModal.vue?vue&type=script&lang=js"
export * from "./AjanlatArImportModal.vue?vue&type=script&lang=js"
import style0 from "./AjanlatArImportModal.vue?vue&type=style&index=0&id=71d0ce36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d0ce36",
  null
  
)

export default component.exports